import pesquisaCombo from './js/pesquisaCombo'
import mascaras from './js/mascaras'
import filtros from './js/filtros'
import mascaraMoeda from "../components/mascaraMoeda";
import ValidacaoBase from './js/ValidacaoBase'
import datePicker from "../components/date-picker";
import uploadFile from "../components/upload-file";
import textFieldValidador from "../components/text-field-validador";
import textFieldValidadorDelete from "../components/text-field-validador-delete";
import dialogObservacao from "../components/dialog-observacao";
import moment from "moment";
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import fornecedorService from "../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */


export default {
  name: 'util',
  mixins: [pesquisaCombo, mascaras, ValidacaoBase, datePicker, uploadFile, mascaraMoeda, filtros, textFieldValidador, dialogObservacao, textFieldValidadorDelete],
  components: { /*Componentes utilizados*/
    datePicker,
    uploadFile,
    mascaraMoeda,
    textFieldValidador,
    dialogObservacao,
    textFieldValidadorDelete,
    'popper': Popper,
    fornecedorService
  },
  data() {//Declaracao de variaveis
    return {
      dadosBasicosSocioDirigente: [
        {
          text: this.$t("label.nome"), align: "left", sortable: false, width: 300
        },
        {
          text: this.$t("label.documentoIdentificacao"), align: "left", sortable: false, width: 130
        },
        {
          text: this.$t("label.brasileiro") + "?", align: "center", sortable: false, width: 70
        }
      ],
      cabecalhoDirigentes: [ /*Cabeçalho da data-table*/
        {
          text: this.$t("label.cargo"), align: "center", sortable: false, width: 120
        }
      ],
      cabecalhoSocios: [ /*Cabeçalho da data-table*/
        {
          text: this.$t("label.percentual"), align: "center", sortable: false, width: 120
        }
      ],
      headersReceita: [
        {
          text: this.$t("label.capitalSocial"), align: "left", sortable: false, width: 300
        },
        {
          text: this.$t("label.receitaOperacionalLiquida"), align: "left", sortable: false, width: 300
        },
        {
          text: this.$t("label.receitaOperacionalBruta"), align: "left", sortable: false, width: 100
        }
      ],
      headersBalanco: [
        {
          text: this.$t("label.numLivroDiario"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("label.dataDoBalanco"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("label.dataValidade"),
          align: "center",
          sortable: false,
        }
      ],
      headersConcordataEFalencia: [
        {
          text: this.$t("label.numeroDocumento"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("label.dataEmissao"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("label.dataValidade"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("label.situacao"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("label.codDeControle"),
          align: "left",
          sortable: false,
        }
      ],
      cabecalhoQualificacaoTecnica: [ /*Cabeçalho da data-table*/
        {
          text: "Nome",
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: this.$t('label.numeroDocumento'),
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: this.$t('label.dataValidade'),
          align: "center",
          sortable: false,
          width: 100
        }
      ],
      cabecalhoFamilia: [ /*Cabeçalho da data-table*/
        {
          text: "Nome do Produto ou Serviço",
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: this.$t("label.ramoAtividade"),
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: this.$t("label.tipoDoItem"),
          align: "left",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("label.tipoDeQualificacao"),
          align: "left",
          sortable: false,
          width: 100
        }
      ],
      cabecalhoResumoAlteracao: [ /*Cabeçalho da data-table*/
        {
          id: 1,
          text: "Campo",
          width: 200
        },
        {
          id: 2,
          text: "Valor Antigo",
          width: 250
        },
        {
          id: 3,
          text: "Valor Atual",
          width: 250
        }
      ],
      displayResumoAlteracao: {
        "$id": {"nome": "hide"},
        "nomFantasia": {"nome": "Nome Fantasia"},
        "endEmail": {"nome" : "E-mail"},
        "endEmail2": {"nome": "E-mail Adicional"},
        "endEmail3": {"nome" : "E-mail Adicional"},
        "arquivoUpload": {"nome": "Anexo"},
        "dataContratoSocial": {"nome" : "Data do Contrato Social"},
        "documentoRg": {"nome": "Rg"},
        "orgaoEmissorRg": {"nome" : "Órgão Emissor do RG"},
        "dataExpedicaoRg": {"nome" : "Data da Expedição do RG"},
        "cpfCnpj": {"nome" : "Cpf/Cnpj"},
        "numDocumentoSEI": {"nome" : "N° Documento SEI"},
        "nomSocial": {"nome" : "Nome Social"}
      },
      displayAbaResumoAlteracao: {
        "FornecedorSolicitacao": {"nome": "Dados do Fornecedor"},
        "FornecedoresHabilitacaoJuridica": {"nome" : "Habilitação Jurídica"},
        "FamiliaSolicitacao": {"nome": "Família"},
        "QualificacaoTecnica": {"nome" : "Qualificação Técnica"},
        "RegularidadeFiscTrab": {"nome": "Regularidade Fiscal e Trabalhista"},
        "BalancoFinanceiro": {"nome" : "Balanço Financeiro"},
        "ConcordataFalencia": {"nome": "Concordata e Falência"}
      }
    }
  },
  methods: {//Declaracao de todos os metodos
    customRoundNumber(number, decimalPlaces){
      const multiplier = Math.pow(10, decimalPlaces);
      return Math.round(number * multiplier) / (multiplier)
    },
    subStrUpload(str,str2) {
    // eslint-disable-next-line
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

    //Se for link
    if(regex.test(str) && str2!=null) {
      return  str2;
    }

      return (str != null ? str.substring(str.indexOf('_') + 1) : str)
    },
    removeItemOfArray(arr, value) {
      return arr.filter(function (ele) {
        return ele !== value;
      });
    },
    retornaIfCadastrado(valor) {
      if(valor){
        return valor;
      }else{
        return "<i class='labelNaoCadastrado'>Não Cadastrado</i>";
      }

    },
    nomeAnexoIfCadatrado(anexo) {
      if(anexo){
        return this.subStrUpload(anexo);
      }else{
        return "<i class='labelNaoCadastrado'>Não Cadastrado</i>";
      }

    },
    verificaDataVencida(data) {
      var retorno = false;
      if (data) {
        if (moment(data).isBefore(moment().format("YYYY-MM-DD"))) {
          retorno = true;
        }
      }
      return retorno;
    },
    adcionaZeroEsquerda(cep,isCep){      
      if(!isCep) return cep;
      if(cep.length < 8 && isCep) return cep.padStart(8, '0')
      return cep;
    },
    verificaDataIguais(data1,data2) {
      return (data1 && data2) ? moment(data1).format("YYYY-MM-DD")===moment(data2).format("YYYY-MM-DD") : false;
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    getLabelCampo(propriedade){
      //resgatar o label do campo
        if(propriedade != null && propriedade.trim() !== ""){
            propriedade = propriedade.charAt(0).toLowerCase() + propriedade.slice(1);
            // Realizo um de/para na propriedade
            if (this.displayResumoAlteracao[propriedade]){
                return this.displayResumoAlteracao[propriedade]["nome"];
            }else{
              //Caso não ache o de/para...
              if(propriedade.length > 3 && propriedade[3].match(/[A-Z]/) != null){
                  //chama função que elimina os prefixos
                propriedade = this.eliminaPrefixos(propriedade);
              }else{
                //A primeira letra será caixa alta
                propriedade = propriedade.charAt(0).toUpperCase() + propriedade.slice(1);
              }
              //Adiciona espaço em branco antes de uma letra maiuscula
              propriedade = this.setEspacoEmBranco(propriedade);
           }
        }
       return propriedade;
    },

    eliminaPrefixos(propriedade){
      //Elimina os prefixos
      if(propriedade.startsWith("end") || propriedade.startsWith("num") || propriedade.startsWith("nom")){
          propriedade = propriedade.replace(/^.{3}/g, '');
      }else if(propriedade.startsWith("tip")){
          propriedade = propriedade.replace(/^.{3}/g, 'Tipo');
      }
      return propriedade;
    },

    setEspacoEmBranco(propriedade){
      if(propriedade.match(/[A-Z][a-z]+|[0-9]+/g) != null && !(propriedade.match(/^[0-9]{2}.[0-9]{2}/) != null)){
        propriedade = propriedade.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
      }
      return propriedade;
    },

    getLabelAba(aba){
      //resgatar o label da aba
        if(aba != null && aba.trim() !== ""){
           // Realizo um de/para na propriedade
            if (this.displayAbaResumoAlteracao[aba]){
                aba = this.displayAbaResumoAlteracao[aba]["nome"];
                return aba;
            }else{
               //Adiciona espaço em branco antes de uma letra maiuscula
                return aba.match(/[A-Z\-][a-z\-]+|[0-9\-]+/g).join(" ");
            }
        }
       return aba;
    },
    isLink(valor){
      if(valor == null || valor === ""){
        return false;
      }
        // eslint-disable-next-line
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/g;
        return regex.test(valor);
    },
    retornaNomeQualificacaoTecnica(listaDocsQualificacaoTecnica, codDocumento) {
      // Garantir que é um array e tem elementos
      if (!Array.isArray(listaDocsQualificacaoTecnica) || listaDocsQualificacaoTecnica.length === 0) {
        return "";
      }

      const docQualificacao = listaDocsQualificacaoTecnica.find(r => codDocumento === r.codDocumento);

      // ⚠️ .find() retorna undefined, não null!
      return docQualificacao && docQualificacao.nomDocumento ? docQualificacao.nomDocumento : "";
    },
    baixarDocumento(arquivo) {
      //baixar o documento
      const numCgcFornecedor =  this.model.numCgcFornecedor.replace(/[\W_]+/g, "");
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    },
    testePeloMenos1QualificacaoTecnica(array) {
      //verificar se existe pelo menos um documento
      return array.find(
        x =>
          // x.numDocumento &&
          // x.numDocumento.toString().trim() !== "" &&
          // (x.dtVencimento && x.dtVencimento.toString().trim() !== "") &&
          ((x.arquivoUpload && x.arquivoUpload.toString().trim() !== "") ||
            (!x.arquivoUpload && x.file.arquivoUpload))
      );
    },
    testePeloMenos1CampoQualificacaoTecnica(array) {
      //verificar se foi preenchido pelo menos um campo
      return array.find(
        x =>
          // (x.numDocumento && x.numDocumento.toString().trim() !== "") ||
          // (x.dtVencimento && x.dtVencimento.toString().trim() !== "") ||
          ((x.arquivoUpload && x.arquivoUpload.toString().trim() !== "") ||
            (!x.arquivoUpload && x.file.arquivoUpload))
      );
    },

  },
  filters: {

  }
}
